import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISearchCountModel } from '@apps-common/types/general'
import { IUnitTaskGroupsSearchParamsModel } from '@apps-common/types/portal/unit-tasks'

export const QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_GROUPS_COUNT = (model?: IUnitTaskGroupsSearchParamsModel) =>
  ['searchUnitTaskGroupsCount', model?.groupName, model?.status, model?.taskType, model?.archived, model?.take, model?.orderBy].filter(
    Boolean
  )

export const searchUnitTaskGroupsCount = async (model: IUnitTaskGroupsSearchParamsModel): Promise<ISearchCountModel> =>
  axios.post('/management/UnitProgramTask/SearchTaskGroupsCount', model).then((res) => res.data?.data)

type QueryFnType = typeof searchUnitTaskGroupsCount

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IUnitTaskGroupsSearchParamsModel
}

export const useManagementSearchUnitTaskGroupsCount = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, staleTime: 0, gcTime: 0 },
    queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_GROUPS_COUNT(model),
    queryFn: () => searchUnitTaskGroupsCount(model)
  })
